import type { Form } from '../../../../common/types/form';
import type { Client } from '../../../../common/types/client';

const policeMeasureForm: Form<Client> = {
  key: 'policeMeasure',
  fields: [
    {
      key: 'policeMeasure',
      label: 'Maßnahmen der Polizei',
      fieldTypes: 'checkboxSelect',
      xsWidth: 12,
      options: [
        { label: 'Platzverweis', value: 'dismissal' },
        { label: 'Kontaktverbot', value: 'restrainingOrder' },
        { label: 'Anzeige', value: 'complaint' },
        { label: 'Vermerk', value: 'note' },
        { label: 'Gefährderansprache', value: 'dangerousSpeech' },
        { label: 'Gewahrsamnahme', value: 'detention' },
        { label: 'Festnahme', value: 'arrest' },
        { label: 'Einweisung', value: 'receptionOrder' },
        { label: 'Meldung ans Jugendamt', value: 'notificationToTheYouthWelfareOffice' },
      ],
    },
    {
      key: 'restrainingOrderDate',
      label: 'Kontaktverbot bis',
      fieldTypes: 'date',
      isVisible: (client) => client.policeMeasure !== undefined && client.policeMeasure.includes('restrainingOrder'),
    },
    {
      key: 'complaintReason',
      label: 'Anzeige wegen',
      fieldTypes: 'text',
      isVisible: (client) => client.policeMeasure !== undefined && client.policeMeasure.includes('complaint'),
    },
  ],
};

export default policeMeasureForm;
